/**
 * Builds the `session_start` event: one row describing the device behind a
 * session, emitted once when that session's id is minted.
 *
 * ## Why the id is a parameter
 *
 * This runs *inside* `getSessionId()` — the mint is what triggers it. Calling
 * `getSessionId()` from here would recurse. The id is passed in for that reason,
 * not as a stylistic preference; see the mint listener in `session.ts`.
 *
 * ## What is not here
 *
 * No `source` and no `user_id`: the server sets both from the request itself and
 * overwrites whatever the body claimed, because this endpoint is public and
 * unauthenticated. Sending them would be noise at best and a forgery attempt at
 * worst.
 */

import { describeDevice } from "./device";
import type { SessionStartEvent } from "./types";

export const buildSessionStartEvent = (sessionId: string): SessionStartEvent => ({
  name: "session_start",
  // Advisory, like every client clock. The server clamps it against its own.
  occurred_at: new Date().toISOString(),
  session_id: sessionId,
  hub_id: null,
  project_id: null,
  properties: describeDevice(),
});
